export function saveState(key, state) {
	try {
		sessionStorage.setItem(key, JSON.stringify(state));
	} catch (e) {
		console.error('Error svaing state', e);
	}
}

export function loadState(key) {
	try {
		const data = sessionStorage.getItem(key);
		return data ? JSON.parse(data) : null;
	} catch (e) {
		console.error('Error loading state', e);
		return {};
	}
}

export function clearState(key) {
	try {
		sessionStorage.removeItem(key);
	} catch (e) {
		console.error('Error clearing data', e);
	}
}
